"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default={ELEMENT:1,TEXT:3,COMMENT:8};